export const vantagensData = [
  {
    icon: "✅👩‍💼",
    title: "Included Quality Assurance (QA)",
    text: "Unlike the competition that charges extra, our QA review by a second expert is always included to guarantee maximum accuracy.",
  },
  {
    icon: "🚀⏳",
    title: "Free Expedited Translations (Exclusive Advantage)",
    text: "We offer 5 orders with free 4-hour delivery, an ideal advantage for when time is your biggest enemy.",
  },
  {
    icon: "🖥️📊",
    title: "Intuitive Management Platform",
    text: "Access an easy-to-use dashboard where you can see the status of all your translation orders, organized by client.",
  },
  {
    icon: "📂🔒",
    title: "A Centralized Archive",
    text: "All your clients' documents are stored securely and are easily accessible in one place. Say goodbye to searching for translations in your inbox.",
  },
  {
    icon: "📜⚖️",
    title: "Legally Valid Translations",
    text: "Our translations are prepared for use in any legal process, complying with all regulations.",
  },
  {
    icon: "⏱️🔍",
    title: "Real-Time Traceability",
    text: "Never wonder where a document is again. Our platform allows you to follow the progress of every translation from start to finish.",
  },
];
